import { HtmlParser } from '@calendly/html-parser'
import { I18n } from '@calendly/i18n'
import { Badge } from '@calendly/ui/components/badge'
import { Button } from '@calendly/ui/components/button'
import { FlexLayout } from '@calendly/ui/components/flex-layout'
import { Link } from '@calendly/ui/components/link'
import { TitleText } from '@calendly/ui/components/typography'

import { useBillingPath } from 'features/billing'
import { useIsSettingsModalLayout } from 'features/settings_modal/layout_context'

import { BadgeWrapper, Description } from '../styles'

const SsoHelpCenterLink = ({ children }) => (
  <Link href="https://calendly.com/help/saml-single-sign-on-sso-overview" target="_blank" rel="noreferrer noopener">{children}</Link>
)

export const Upgrade = () => {
  const inSettingsModal = useIsSettingsModalLayout()
  const contactSalesPath = useBillingPath('/contact_sales', { interest: 'SSO' })

  return (
    <div>
      {!inSettingsModal ? (
        <BadgeWrapper>
          <Badge type="new">{I18n.t('publisher.billing.tiers.enterprise')}</Badge>
        </BadgeWrapper>
      ) : null}
      <FlexLayout direction="column" gap={16}>
        <TitleText level={2} size="medium">{I18n.t('publisher.organization_settings.sso.upgrade.header')}</TitleText>
        <Description>{HtmlParser(I18n.t('publisher.organization_settings.sso.upgrade.description'), { SsoHelpCenterLink })}</Description>
      </FlexLayout>
      <Button as="a" href={contactSalesPath}>
        {I18n.t('publisher.billing.contact_sales.contact_us')}
      </Button>
    </div>
  )
}
